
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/customer-studio/journeys/create",
      function () {
        return require("private-next-pages/customer-studio/journeys/create.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/customer-studio/journeys/create"])
      });
    }
  